import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler, PrimariaApi } from "@uxland/primary-shell";
import { AddHistoryItemHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapAddHistoryItem = (broker: BrokerExtensions, api: PrimariaApi) => {
  request = broker.registerRequest(api.broker.events.activityHistory.addHistoryItemRequest, AddHistoryItemHandler);
};

export const teardownAddHistoryItem = () => {
  request?.dispose();
};
